import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { chartMapping } from '../../shared/data/chartSeriesChange';
import { initialSelectedColumns } from '../../shared/data/initialColumnsTable';

import { AlphaTagsActionType, AlphaTagsStoreElement } from './AlphaListsReducer.types';

const tagsColumns = ['region', 'universe', 'correlation', 'sharpe', 'returns', 'turnover', 'fitness'];

export const initialSelectedColumnsTags = initialSelectedColumns()
  .filter((option: any) => tagsColumns.indexOf(option.id) >= 0)
  .map((option: any) => {
    const newOption = Object.assign({}, option);
    newOption.active = true;

    return newOption;
  });

// @ts-ignore
export const initialState: AlphaTagsStoreElement = Immutable.fromJS({
  userLists: Immutable.List(),
  userListsOptions: Immutable.List(),
  fetchingData: false,
  currentList: null,
  fetchingCurrentList: false,
  fetchingTagAlpha: false,
  fetchingInnerCorrelation: false,
  innerCorrelationData: null,
  selectedColumns: initialSelectedColumnsTags,
  fetchingTagsAlphas: false,
  tagAlphas: null,
  fetchingUpdateList: false,
  innerAndSelfMessage: null,
  innerAndSelfIsAvailable: true,
  listsCount: null,
});

export const AlphaListsReducer = handleActions<any>(
  {
    REQUEST_USER_TAGS: (state: AlphaTagsStoreElement) => state.set('fetchingData', true),
    ERROR_USER_TAGS: (state: AlphaTagsStoreElement) => state.set('fetchingData', false),
    SET_USER_TAGS: (state: AlphaTagsStoreElement, action: AlphaTagsActionType) =>
      state.merge(
        Immutable.fromJS({
          fetchingData: false,
          userLists: Immutable.fromJS(action.payload.results),
          listsCount: action.payload.count,
        })
      ),
    REQUEST_USERLIST_OPTIONS: (state: AlphaTagsStoreElement) => state.set('fetchingData', true),
    RESPONSE_USERLIST_OPTIONS_SUCCESS: (state: AlphaTagsStoreElement, action: any) =>
      state.set('fetchingData', false).set('userListsOptions', Immutable.fromJS(action.payload)),
    RESPONSE_USERLIST_OPTIONS_FAILURE: (state: AlphaTagsStoreElement) => state.set('fetchingData', false),
    REQUEST_CREATE_USERLIST: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', true),
    DONE_CREATE_USERLIST: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', false),
    ERROR_CREATE_USERLIST: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', false),
    REQUEST_UPDATE_USERLIST: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', true),
    DONE_UPDATE_USERLIST: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', false),
    ERROR_UPDATE_USERLIST: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', false),
    RESPONSE_UPDATE_ALPHA: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', false),
    REQUEST_UPDATE_ALPHA: (state: AlphaTagsStoreElement) => state.set('fetchingUpdateList', true),
    REQUEST_ID_TAG: (state: AlphaTagsStoreElement) => state.set('fetchingCurrentList', true).set('innerCorrelationData', null),
    RESPONSE_ID_TAG_FAILURE: (state: AlphaTagsStoreElement) => state.set('fetchingCurrentList', false),
    RESPONSE_ID_TAG_SUCCESS: (state: AlphaTagsStoreElement, action: AlphaTagsActionType) =>
      state.set('fetchingCurrentList', false).set('currentList', Immutable.fromJS(action.payload)),
    REQUEST_INNER_CORRELATION_TAG: (state: AlphaTagsStoreElement) => state.set('fetchingInnerCorrelation', true),
    AUTHENTICATION_LOGIN: (state: AlphaTagsStoreElement, action: any) => {
      return state;
    },
    CHANGE_INNER_CORRELATION_COLORS: (state: AlphaTagsStoreElement, action: AlphaTagsActionType) => {
      const innerCorrelationDataProperties = state.getIn(['innerCorrelationData', 'chartData', 'schema', 'properties']);
      if (innerCorrelationDataProperties && action.payload) {
        const recordsWithColor = innerCorrelationDataProperties
          // @ts-ignore
          .filter((property: any) => property.get('name') !== 'date')
          .map((property: any, index: number) => {
            const colorInfo: any = action.payload;
            const colorObject = colorInfo.find((el: any) => el.id === property.get('name'));
            if (colorObject) {
              // @ts-ignore
              return state.getIn(['innerCorrelationData', 'chartData', 'records', index]).set('color', colorObject.color);
            } else {
              return state.getIn(['innerCorrelationData', 'chartData', 'records', index]);
            }
          });

        return state.setIn(['innerCorrelationData', 'chartData', 'records'], recordsWithColor);
      } else {
        return state;
      }
    },
    RESPONSE_INNER_CORRELATION_TAG_FAILURE: (state: AlphaTagsStoreElement) => state.set('fetchingInnerCorrelation', false),
    RESPONSE_INNER_CORRELATION_TAG_SUCCESS: (state: AlphaTagsStoreElement, action: AlphaTagsActionType) => {
      const getRecordSeries = chartMapping['pnl-by-sector'];
      const schema = action.payload.pnl.schema;
      const records = action.payload.pnl.records;
      const innerCorrelationData = Immutable.fromJS({
        inner: action.payload.inner,
        chartData: action.payload.pnl,
        chartType: 'pnl-by-sector',
        // @ts-ignore
      }).setIn(
        ['chartData', 'records'],
        Immutable.fromJS(getRecordSeries({ chartDataSchema: schema, chartDataRecords: records, name: 'anonymous' }))
      );

      return state.set('fetchingInnerCorrelation', false).set('innerCorrelationData', innerCorrelationData);
    },
    SET_SELECTED_COLUMNS_TAGS: (state: AlphaTagsStoreElement, action: AlphaTagsActionType) =>
      state.set('selectedColumns', Immutable.fromJS(action.payload.selectedColumns)),
    RESET_SELECTED_COLUMNS_TAGS: (state: AlphaTagsStoreElement) =>
      state.set('selectedColumns', Immutable.fromJS(initialSelectedColumnsTags)),
    REQUEST_TAG_ALPHAS: (state: AlphaTagsStoreElement) => state.set('fetchingTagsAlphas', true),
    RESPONSE_TAG_ALPHAS_FAILURE: (state: AlphaTagsStoreElement) => state.set('fetchingTagsAlphas', false),
    RESPONSE_TAG_ALPHAS_SUCCESS: (state: AlphaTagsStoreElement, action: AlphaTagsActionType) =>
      state.set('fetchingTagsAlphas', false).set('tagAlphas', Immutable.fromJS(action.payload)),
    TOO_MANY_ALPHAS_IN_LIST: (state: AlphaTagsStoreElement) =>
      state.set('innerAndSelfIsAvailable', false).set('innerAndSelfMessage', 'Comparation between alphas cannot be done.'),
    CLEAN_ALPHAS_LIST_MESSAGE: (state: AlphaTagsStoreElement) =>
      state.set('innerAndSelfIsAvailable', true).set('innerAndSelfMessage', null),
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);
